import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-fluid pb-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-secondary text-xs py-2"
}
const _hoisted_3 = { class: "d-flex flex-wrap gap-2 justify-content-between align-items-start mb-4 px-xxl-5" }
const _hoisted_4 = {
  class: "mb-0 fw-bold",
  style: {"color":"var(--detail-section-label)"}
}
const _hoisted_5 = { class: "card mx-auto mx-xxl-5 mb-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "d-flex flex-column flex-sm-row gap-4 align-items-start" }
const _hoisted_8 = {
  class: "position-relative",
  style: {"flex":"none","padding-top":"0.25rem"}
}
const _hoisted_9 = { class: "detail-avatar-wrapper" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "detail-avatar-placeholder"
}
const _hoisted_12 = { class: "flex-fill" }
const _hoisted_13 = { class: "row g-3" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "form-label small fw-bold" }
const _hoisted_16 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_17 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-label small fw-bold" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  class: "badge bg-secondary border-0",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#editGmail"
}
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-label small fw-bold" }
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  class: "badge bg-secondary border-0",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#editPassword"
}
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = { class: "form-label small fw-bold" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_32 = { class: "col-sm-6" }
const _hoisted_33 = { class: "form-label small fw-bold" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_36 = { class: "col-sm-3" }
const _hoisted_37 = { class: "form-label small fw-bold" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "col-sm-9" }
const _hoisted_40 = { class: "form-label small fw-bold" }
const _hoisted_41 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_42 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_43 = {
  class: "d-flex justify-content-end gap-2 pt-3 mt-3",
  style: {"border-top":"1px solid var(--detail-divider)"}
}
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_46 = { class: "row mx-auto mx-xxl-5 mb-4 g-4" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "card h-100" }
const _hoisted_49 = { class: "card-body" }
const _hoisted_50 = { class: "detail-section-label" }
const _hoisted_51 = { class: "detail-section-label mt-4" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = {
  key: 0,
  class: "input-group"
}
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_56 = {
  key: 1,
  class: "fa fa-solid fa-trash"
}
const _hoisted_57 = ["placeholder"]
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "card h-100" }
const _hoisted_60 = { class: "card-body" }
const _hoisted_61 = { class: "detail-section-label" }
const _hoisted_62 = { class: "row align-items-end g-3" }
const _hoisted_63 = { class: "col-6" }
const _hoisted_64 = { class: "form-label small fw-bold" }
const _hoisted_65 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_66 = ["checked", "disabled"]
const _hoisted_67 = { class: "form-check-label" }
const _hoisted_68 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary ms-1",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_69 = { class: "col-6" }
const _hoisted_70 = { class: "form-label small fw-bold" }
const _hoisted_71 = ["value"]
const _hoisted_72 = ["value"]
const _hoisted_73 = {
  class: "rounded-3 p-3 d-flex justify-content-between align-items-center",
  style: {"background":"linear-gradient(310deg,#141727,#3a416f)"}
}
const _hoisted_74 = {
  class: "text-uppercase fw-bold mb-1",
  style: {"font-size":"0.65rem","color":"rgba(255,255,255,0.5)","letter-spacing":"0.06em"}
}
const _hoisted_75 = { class: "d-flex align-items-baseline gap-2" }
const _hoisted_76 = { style: {"font-size":"1.8rem","font-weight":"700","color":"#fff","letter-spacing":"-0.03em"} }
const _hoisted_77 = { style: {"font-size":"0.72rem","font-weight":"700","color":"rgba(255,255,255,0.4)"} }
const _hoisted_78 = {
  key: 0,
  type: "button",
  class: "btn btn-sm",
  "data-bs-target": "#balance-modal",
  "data-bs-toggle": "modal",
  style: {"background":"rgba(255,255,255,0.12)","color":"#fff","border":"none","font-size":"0.7rem","font-weight":"700","text-transform":"uppercase","letter-spacing":"0.02em"}
}
const _hoisted_79 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_80 = {
  type: "button",
  class: "btn btn-sm btn-outline-primary w-100",
  "data-bs-target": "#monthly-payment-modal",
  "data-bs-toggle": "modal"
}
const _hoisted_81 = { class: "card mx-auto mx-xxl-5" }
const _hoisted_82 = { class: "card-header d-flex flex-wrap gap-2 justify-content-between align-items-center" }
const _hoisted_83 = {
  class: "mb-0 fw-bold",
  style: {"color":"var(--detail-section-label)"}
}
const _hoisted_84 = { class: "d-flex gap-2" }
const _hoisted_85 = { class: "card-body p-0" }
const _hoisted_86 = {
  key: 0,
  class: "text-muted small p-3 mb-0"
}
const _hoisted_87 = { class: "table-responsive payhist" }
const _hoisted_88 = { class: "table table-sm mb-0" }
const _hoisted_89 = { class: "payhist-cell-icon" }
const _hoisted_90 = { class: "payhist-balance" }
const _hoisted_91 = { class: "payhist-actor" }
const _hoisted_92 = { class: "payhist-avatar" }
const _hoisted_93 = {
  key: 0,
  class: "payhist-note-pill"
}
const _hoisted_94 = {
  key: 1,
  class: "payhist-dash"
}
const _hoisted_95 = { class: "payhist payhist-footer" }
const _hoisted_96 = {
  key: 0,
  class: "text-muted small p-3 mb-0"
}
const _hoisted_97 = { class: "table-responsive payhist" }
const _hoisted_98 = { class: "table table-sm mb-0" }
const _hoisted_99 = { class: "payhist-period-pill" }
const _hoisted_100 = { class: "payhist-balance fw-bold" }
const _hoisted_101 = { class: "payhist-actor" }
const _hoisted_102 = { class: "payhist-avatar" }
const _hoisted_103 = { class: "payhist-cell-icon" }
const _hoisted_104 = {
  key: 0,
  class: "payhist-note-pill"
}
const _hoisted_105 = {
  key: 1,
  class: "payhist-dash"
}
const _hoisted_106 = { class: "payhist-status-cell" }
const _hoisted_107 = { class: "payhist-voided-badge" }
const _hoisted_108 = { class: "payhist-voided-meta" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { class: "payhist payhist-footer" }
const _hoisted_113 = {
  class: "modal fade",
  id: "balance-modal",
  tabindex: "-1",
  "aria-labelledby": "balanceModalLabel",
  "aria-hidden": "true"
}
const _hoisted_114 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_115 = { class: "modal-content border-0 rounded-3" }
const _hoisted_116 = { class: "modal-header border-0 pb-0" }
const _hoisted_117 = { class: "d-flex align-items-center gap-2" }
const _hoisted_118 = {
  class: "modal-title mb-0",
  id: "balanceModalLabel"
}
const _hoisted_119 = { class: "modal-body" }
const _hoisted_120 = {
  class: "rounded-3 p-3 mb-3",
  style: {"background":"linear-gradient(310deg,#141727,#3a416f)"}
}
const _hoisted_121 = {
  class: "text-uppercase fw-bold mb-1",
  style: {"font-size":"0.65rem","color":"rgba(255,255,255,0.5)","letter-spacing":"0.06em"}
}
const _hoisted_122 = { class: "d-flex align-items-baseline gap-2" }
const _hoisted_123 = { style: {"font-size":"1.8rem","font-weight":"700","color":"#fff","letter-spacing":"-0.03em"} }
const _hoisted_124 = { style: {"font-size":"0.72rem","font-weight":"700","color":"rgba(255,255,255,0.4)"} }
const _hoisted_125 = { class: "form-group mb-3" }
const _hoisted_126 = { class: "form-label" }
const _hoisted_127 = {
  class: "btn-group w-100",
  role: "group"
}
const _hoisted_128 = { class: "form-group mb-3" }
const _hoisted_129 = { class: "form-label" }
const _hoisted_130 = { class: "input-group" }
const _hoisted_131 = ["placeholder"]
const _hoisted_132 = { class: "form-group" }
const _hoisted_133 = { class: "form-label" }
const _hoisted_134 = ["placeholder"]
const _hoisted_135 = { class: "modal-footer border-0" }
const _hoisted_136 = {
  type: "button",
  class: "btn bg-gradient-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_137 = ["disabled"]
const _hoisted_138 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_139 = {
  class: "modal fade",
  id: "monthly-payment-modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_140 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_141 = { class: "modal-content border-0 rounded-3" }
const _hoisted_142 = { class: "modal-header border-bottom" }
const _hoisted_143 = { class: "d-flex align-items-center gap-2" }
const _hoisted_144 = { class: "modal-title mb-0" }
const _hoisted_145 = { class: "modal-body" }
const _hoisted_146 = { class: "form-group" }
const _hoisted_147 = { class: "mb-2" }
const _hoisted_148 = { class: "period-pill-row" }
const _hoisted_149 = ["onClick"]
const _hoisted_150 = { class: "form-group mt-3" }
const _hoisted_151 = { class: "input-group mt-1" }
const _hoisted_152 = { class: "monthly-info-box mt-3 d-flex align-items-start gap-2" }
const _hoisted_153 = { class: "form-group mt-3" }
const _hoisted_154 = ["placeholder"]
const _hoisted_155 = { class: "modal-footer border-0" }
const _hoisted_156 = {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_157 = ["disabled"]
const _hoisted_158 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_159 = {
  key: 1,
  class: "fas fa-calendar-plus me-1"
}
const _hoisted_160 = {
  class: "modal fade",
  id: "editGmail",
  tabindex: "-1",
  "aria-labelledby": "editGmailLabel",
  "aria-hidden": "true"
}
const _hoisted_161 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_162 = { class: "modal-content border-0 rounded-3" }
const _hoisted_163 = { class: "modal-header border-0 pb-0" }
const _hoisted_164 = { class: "d-flex align-items-center gap-2" }
const _hoisted_165 = {
  class: "modal-title mb-0",
  id: "editGmailLabel"
}
const _hoisted_166 = { class: "modal-body" }
const _hoisted_167 = { class: "mb-3" }
const _hoisted_168 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_169 = { class: "modal-footer border-0" }
const _hoisted_170 = {
  type: "button",
  class: "btn bg-gradient-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_171 = ["disabled"]
const _hoisted_172 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_173 = {
  class: "modal fade",
  id: "editPassword",
  tabindex: "-1",
  "aria-labelledby": "editPasswordLabel",
  "aria-hidden": "true"
}
const _hoisted_174 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_175 = { class: "modal-content border-0 rounded-3" }
const _hoisted_176 = { class: "modal-header border-0 pb-0" }
const _hoisted_177 = { class: "d-flex align-items-center gap-2" }
const _hoisted_178 = {
  class: "modal-title mb-0",
  id: "editPasswordLabel"
}
const _hoisted_179 = { class: "modal-body" }
const _hoisted_180 = { class: "mb-3" }
const _hoisted_181 = { class: "input-group" }
const _hoisted_182 = ["onUpdate:modelValue", "placeholder", "type"]
const _hoisted_183 = { class: "modal-footer border-0" }
const _hoisted_184 = {
  type: "button",
  class: "btn bg-gradient-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_185 = ["disabled"]
const _hoisted_186 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

import StorageService from '@/services/StorageService'
import { ErrorMessage, Field, Form } from 'vee-validate'
import dayjs from 'dayjs'
import Driver from '@/models/Driver'
import DriverRepository from '@/repositories/DriverRepository'
import { Constants } from '@/constants/Constants'
import ToastService from '@/services/ToastService'
import ImageLoader from '@/components/ImageLoader.vue'
import RosterPanel from '@/components/vehicles/RosterPanel.vue'
import VoidMonthlyPaymentModal from '@/components/drivers/VoidMonthlyPaymentModal.vue'
import i18n from '@/plugins/i18n'
import { computed, onBeforeMount, onMounted, ref, Ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useDriversStore } from '@/services/stores/DriversStore'
import { mixed, object, string } from 'yup'
import { hide } from '@/helpers/ModalHelper'
import { StrHelper } from '@/helpers/StrHelper'
import { useI18n } from 'vue-i18n'
import AuthService from '@/services/AuthService'
import { useSettingsStore } from '@/services/stores/SettingsStore'
import { storeToRefs } from 'pinia'
import { DriverPaymentMode } from '@/constants/DriverPaymentMode'
import { RechargeInterface } from '@/types/RechargeInterface'
import MonthlyPaymentSettingsRepository from '@/repositories/MonthlyPaymentSettingsRepository'
import { MonthlyPaymentInterface } from '@/types/MonthlyPaymentInterface'
const driverEvent = 'image-driver-loaded'

export default /*@__PURE__*/_defineComponent({
  __name: 'Edit',
  setup(__props) {

const driver: Ref<Driver> = ref(new Driver)
const recharges: Ref<RechargeInterface[]> = ref([])
const rechargesTotal = ref(0)
const monthlyPaymentPeriod = ref(dayjs().format('YYYY-MM'))
const monthlyPaymentAmount = ref(0)
const monthlyPaymentNote = ref('')
const monthlyPayments: Ref<MonthlyPaymentInterface[]> = ref([])
const monthlyPaymentsTotal = ref(0)
const voidModalRef = ref<InstanceType<typeof VoidMonthlyPaymentModal> | null>(null)
const suggestedAmount = ref(0)
const types: Ref<Array<string>> = ref(Constants.DOC_TYPES)
const showPassword = ref(false);
const removingDevice = ref(false)
const savingPaymentMode = ref(false)
const lastPaymentMode: Ref<DriverPaymentMode | undefined> = ref(undefined)
const pathDriver = StorageService.driverPath
const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const driverStore = useDriversStore()
const currentUser = AuthService.getCurrentUser()
const currentUserName = computed(() => currentUser.name || '—')
const periodOptions = computed(() =>
  Array.from({ length: 5 }, (_, i) => {
    const d = dayjs().subtract(i, 'month')
    const raw = d.format('MMM YY')
    const label = raw.charAt(0).toUpperCase() + raw.slice(1)
    return { label, value: d.format('YYYY-MM') }
  })
)
const loadingDriver = ref(false)
const submittingDriver = ref(false)
const submittingEmail = ref(false)
const submittingPassword = ref(false)
const submittingBalance = ref(false)
const submittingMonthlyPayment = ref(false)
const togglingEnabled = ref(false)
const newBalance = ref(0)
const rechargeNote = ref('')
const adjustmentType = ref<'add' | 'subtract'>('add')
const activeHistoryTab = ref<'saldo' | 'mensualidades'>('saldo')
const { branchSelected } = storeToRefs(useSettingsStore())
const schema = object().shape({
  name: string().required().min(3),
  phone: string().required().min(8),
  docType: mixed().oneOf(Constants.DOC_TYPES).required(),
  document: string().required().min(6).max(10),
})

watch(driver, (newDriver) => {
  driver.value.name = StrHelper.toCamelCase(newDriver.name ?? '')
  driver.value.phone = StrHelper.formatNumber(newDriver.phone ?? '')
}, { deep: true })

const schemaEmail = object().shape({
  email: string().required().email()
})

const schemaPassword = object().shape({
  password: string().required()
})


function goBack() {
  router.back()
}

async function loadRecharges(): Promise<void> {
  if (!driver.value.id) return
  try {
    const result = await DriverRepository.listRecharges(driver.value.id)
    recharges.value = result.recharges
    rechargesTotal.value = result.total
  } catch (e) {
    // silent fail — history is non-critical
  }
}

async function loadMonthlyPayments(): Promise<void> {
  if (!driver.value.id) return
  try {
    const result = await DriverRepository.listMonthlyPayments(driver.value.id)
    monthlyPayments.value = result.rows
    monthlyPaymentsTotal.value = result.total
  } catch (e) {
    // silent fail — history is non-critical
  }
}

async function loadSuggestedAmount(): Promise<void> {
  try {
    const settings = await MonthlyPaymentSettingsRepository.get()
    suggestedAmount.value = settings.suggested_amount
    monthlyPaymentAmount.value = settings.suggested_amount
  } catch (e) {
    // silent fail — keep default 0
  }
}

onBeforeMount(() => {
  const id = route.params.id as string
  const driverTmp = driverStore.findById(id)
  if (driverTmp) {
    driver.value = driverTmp
  }
  loadingDriver.value = true
  DriverRepository.getDriver(id)
    .then(async (updatedDriverData) => {
      const updatedDriver = new Driver()
      Object.assign(updatedDriver, updatedDriverData)
      driverStore.addDriver(updatedDriver)
      Object.assign(driver.value, updatedDriver)
      lastPaymentMode.value = driver.value.paymentMode
      await loadRecharges()
      await loadMonthlyPayments()
      await loadSuggestedAmount()
      loadingDriver.value = false
    })
    .catch(async (e) => {
      loadingDriver.value = false
      await ToastService.toast(
        ToastService.ERROR,
        i18n.global.t('common.messages.error'),
        e.message
      )
    })
})

onMounted(() => {
  const balanceModalEl = document.getElementById('balance-modal')
  if (balanceModalEl) {
    balanceModalEl.addEventListener('hidden.bs.modal', () => {
      newBalance.value = 0
      rechargeNote.value = ''
      adjustmentType.value = 'add'
    })
  }
})

function uploadImgDriver(url: string): void {
  driver.value.photoUrl = url
  updateDriver()
}

function updateDriver(): void {
  submittingDriver.value = true
  DriverRepository.update(driver.value).then(async () => {
    submittingDriver.value = false
   await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  }).catch(async e => {
    submittingDriver.value = false
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

function updateEmail(): void {
  submittingEmail.value = true
  DriverRepository.updateEmail(driver.value.id, driver.value.email).then(async () => {
    submittingEmail.value = false
    hide('editGmail')
   await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  }).catch(async e => {
    submittingEmail.value = false
   await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

function updatePassword(): void {
  submittingPassword.value = true
  DriverRepository.updatePassword(driver.value.id, driver.value.password).then(async () => {
    submittingPassword.value = false
    hide('editPassword')
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  }).catch(async e => {
    submittingPassword.value = false
   await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

function addBalance(): void {
  if (!newBalance.value || newBalance.value <= 0) return
  const amount = adjustmentType.value === 'subtract' ? -Math.abs(newBalance.value) : Math.abs(newBalance.value)
  submittingBalance.value = true
  DriverRepository.createRecharge(driver.value, amount, rechargeNote.value).then(async (result) => {
    driver.value.balance = result.driver.balance
    newBalance.value = 0
    rechargeNote.value = ''
    adjustmentType.value = 'add'
    await loadRecharges()
    submittingBalance.value = false
    hide('balance-modal')
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  }).catch(async e => {
    submittingBalance.value = false
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

function addMonthlyPayment(): void {
  submittingMonthlyPayment.value = true
  DriverRepository.createMonthlyPayment(driver.value.id, {
    period: monthlyPaymentPeriod.value,
    amount: monthlyPaymentAmount.value,
    note: monthlyPaymentNote.value || null,
  }).then(async (result) => {
    driver.value.enabled_at = result.driver.enabled_at
    monthlyPaymentPeriod.value = dayjs().format('YYYY-MM')
    monthlyPaymentAmount.value = suggestedAmount.value
    monthlyPaymentNote.value = ''
    await loadMonthlyPayments()
    submittingMonthlyPayment.value = false
    hide('monthly-payment-modal')
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  }).catch(async e => {
    submittingMonthlyPayment.value = false
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

function openVoidModal(payment: MonthlyPaymentInterface): void {
  voidModalRef.value?.open(payment)
}

async function onPaymentVoided(): Promise<void> {
  await loadMonthlyPayments()
}

function onEnable(event: Event): void {
  togglingEnabled.value = true
  const target = event.target as HTMLInputElement
  const previousEnabledAt = driver.value.enabled_at
  driver.value.enabled_at = target.checked ? dayjs().unix() : 0
  DriverRepository.enable(driver.value.id ?? '', driver.value.enabled_at).then(async () => {
    togglingEnabled.value = false
    const message = driver.value.enabled_at == 0 ?
      i18n.global.t('users.messages.disabled') : i18n.global.t('users.messages.enabled')
   await ToastService.toast(ToastService.SUCCESS, message)
  }).catch(async e => {
    togglingEnabled.value = false
    driver.value.enabled_at = previousEnabledAt
   await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

async function removeDevice(): Promise<void> {
  if (removingDevice.value) return
  const previousDevice = driver.value.device
  removingDevice.value = true
  try {
    await DriverRepository.updateDevice(driver.value.id, null)
    driver.value.device = null
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  } catch (e: any) {
    driver.value.device = previousDevice
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  } finally {
    removingDevice.value = false
  }
}

async function onChangePaymentMode(): Promise<void> {
  const previousPaymentMode = lastPaymentMode.value
  savingPaymentMode.value = true
  try {
    await DriverRepository.updatePaymentMode(driver.value.id, driver.value.paymentMode)
    lastPaymentMode.value = driver.value.paymentMode
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  } catch (e: any) {
    driver.value.paymentMode = previousPaymentMode ?? driver.value.paymentMode
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  } finally {
    savingPaymentMode.value = false
  }
}

const initials = (name: string): string => {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '?'
  return parts.slice(0, 2).map(w => w[0]).join('').toUpperCase()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (loadingDriver.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[24] || (_cache[24] = _createElementVNode("span", {
              class: "spinner-border spinner-border-sm me-2",
              role: "status",
              "aria-hidden": "true"
            }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t('common.messages.waiting')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Form), {
        onSubmit: updateDriver,
        "validation-schema": _unref(schema)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("h5", _hoisted_4, _toDisplayString(driver.value.name), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: goBack,
              class: "btn btn-sm btn-outline-secondary"
            }, [
              _cache[25] || (_cache[25] = _createElementVNode("em", { class: "fas fa-arrow-left me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.back')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (driver.value.photoUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: driver.value.photoUrl,
                          class: "detail-avatar-img",
                          alt: "profile_photo"
                        }, null, 8, _hoisted_10))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[26] || (_cache[26] = [
                          _createElementVNode("em", { class: "fa-solid fa-user-astronaut fa-3x text-muted" }, null, -1)
                        ]))]))
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("button", {
                    type: "button",
                    class: "position-absolute detail-avatar-edit-btn",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#image-driver"
                  }, [
                    _createElementVNode("em", { class: "fas fa-pencil" })
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('users.fields.name')), 1),
                      _createVNode(_unref(Field), {
                        name: "name",
                        type: "text",
                        modelValue: driver.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((driver.value.name) = $event))
                      }, {
                        default: _withCtx(({ field, errorMessage, meta }) => [
                          _withDirectives(_createElementVNode("input", _mergeProps({
                            class: "form-control form-control-sm",
                            id: "name",
                            "aria-label": "Name",
                            "aria-describedby": "name-addon",
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            placeholder: _ctx.$t('common.placeholders.name')
                          }, field), null, 16, _hoisted_16), [
                            [_vModelDynamic, field.value]
                          ]),
                          (errorMessage || !meta.dirty)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('users.fields.email')), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.$t('common.placeholders.email'),
                          readonly: "",
                          "aria-label": "Email",
                          name: "email",
                          "aria-describedby": "email-addon",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((driver.value.email) = $event))
                        }, null, 8, _hoisted_21), [
                          [_vModelText, driver.value.email]
                        ]),
                        _createElementVNode("button", _hoisted_22, _toDisplayString(_ctx.$t('common.actions.edit')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('users.fields.password')), 1),
                      _createElementVNode("div", _hoisted_25, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.$t('common.placeholders.password'),
                          readonly: "",
                          "aria-label": "Password",
                          name: "password",
                          "aria-describedby": "password-addon",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((driver.value.password) = $event))
                        }, null, 8, _hoisted_26), [
                          [_vModelText, driver.value.password]
                        ]),
                        _createElementVNode("button", _hoisted_27, _toDisplayString(_ctx.$t('common.actions.edit')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('users.fields.phone')), 1),
                      _createVNode(_unref(Field), {
                        name: "phone",
                        type: "phone",
                        modelValue: driver.value.phone,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((driver.value.phone) = $event))
                      }, {
                        default: _withCtx(({ errorMessage, meta }) => [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((driver.value.phone) = $event)),
                            placeholder: _ctx.$t('common.placeholders.phone'),
                            id: "phone",
                            "aria-label": "Phone",
                            "aria-describedby": "phone-addon"
                          }, null, 8, _hoisted_30), [
                            [_vModelText, driver.value.phone]
                          ]),
                          (errorMessage && !meta.dirty)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('users.fields.phone2')), 1),
                      _createVNode(_unref(Field), {
                        name: "phone2",
                        type: "phone",
                        modelValue: driver.value.phone2,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((driver.value.phone2) = $event))
                      }, {
                        default: _withCtx(({ errorMessage, meta }) => [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((driver.value.phone2) = $event)),
                            placeholder: _ctx.$t('common.placeholders.phone2'),
                            id: "phone2",
                            "aria-label": "Phone 2",
                            "aria-describedby": "phone2-addon"
                          }, null, 8, _hoisted_34), [
                            [_vModelText, driver.value.phone2]
                          ]),
                          (errorMessage && !meta.dirty)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('drivers.fields.doc_type')), 1),
                      _createVNode(_unref(Field), {
                        name: "docType",
                        class: "form-select form-select-sm",
                        id: "doc_type",
                        as: "select",
                        modelValue: driver.value.docType,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((driver.value.docType) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (type, key) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: key,
                              value: type,
                              selected: ""
                            }, _toDisplayString(type), 9, _hoisted_38))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('drivers.fields.document')), 1),
                      _createVNode(_unref(Field), {
                        name: "document",
                        type: "text",
                        modelValue: driver.value.document,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((driver.value.document) = $event))
                      }, {
                        default: _withCtx(({ field, errorMessage, meta }) => [
                          _withDirectives(_createElementVNode("input", _mergeProps({
                            class: "form-control form-control-sm",
                            id: "document",
                            "aria-label": "Document",
                            "aria-describedby": "doc-addon",
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            placeholder: _ctx.$t('drivers.placeholders.document')
                          }, field), null, 16, _hoisted_41), [
                            [_vModelDynamic, field.value]
                          ]),
                          (errorMessage || !meta.dirty)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(errorMessage), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm bg-gradient-secondary",
                  onClick: goBack
                }, _toDisplayString(_ctx.$t('common.actions.close')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-sm bg-gradient-primary",
                  disabled: submittingDriver.value
                }, [
                  (submittingDriver.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                ], 8, _hoisted_44)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("h6", _hoisted_50, [
                    _cache[28] || (_cache[28] = _createElementVNode("em", {
                      class: "fas fa-car-side me-2",
                      style: {"color":"#cb0c9f"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('drivers.detail.section_vehicles')), 1)
                  ]),
                  _cache[31] || (_cache[31] = _createElementVNode("hr", { class: "detail-divider" }, null, -1)),
                  (driver.value.id)
                    ? (_openBlock(), _createBlock(RosterPanel, {
                        key: 0,
                        "driver-id": driver.value.id
                      }, null, 8, ["driver-id"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("h6", _hoisted_51, [
                    _cache[29] || (_cache[29] = _createElementVNode("em", {
                      class: "fas fa-mobile-screen me-2",
                      style: {"color":"#cb0c9f"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('drivers.detail.section_device')), 1)
                  ]),
                  _cache[32] || (_cache[32] = _createElementVNode("hr", { class: "detail-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_52, [
                    (driver.value.device)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "input-group-text" }, [
                            _createElementVNode("em", { class: "fas fa-mobile-screen" })
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm disabled",
                            disabled: "",
                            "aria-label": "Device",
                            name: "device.name",
                            "aria-describedby": "device-addon",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((driver.value.device.name) = $event))
                          }, null, 512), [
                            [_vModelText, driver.value.device.name]
                          ]),
                          _createElementVNode("button", {
                            class: "badge bg-danger border-0",
                            id: "removeDevice",
                            type: "button",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (removeDevice())),
                            disabled: removingDevice.value,
                            style: {"border-radius":"0 .5rem .5rem 0"}
                          }, [
                            (removingDevice.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_55))
                              : (_openBlock(), _createElementBlock("em", _hoisted_56))
                          ], 8, _hoisted_54)
                        ]))
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.$t('common.placeholders.device'),
                          disabled: "",
                          "aria-label": "Device",
                          name: "device",
                          "aria-describedby": "password-addon",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((driver.value.device) = $event))
                        }, null, 8, _hoisted_57)), [
                          [_vModelText, driver.value.device]
                        ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("h6", _hoisted_61, [
                    _cache[33] || (_cache[33] = _createElementVNode("em", {
                      class: "fas fa-wallet me-2",
                      style: {"color":"#cb0c9f"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('drivers.detail.section_status_payments')), 1)
                  ]),
                  _cache[36] || (_cache[36] = _createElementVNode("hr", { class: "detail-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('drivers.fields.status')), 1),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("input", {
                          class: "form-check-input",
                          name: "enable",
                          type: "checkbox",
                          id: "flexSwitchCheckDefault",
                          onChange: onEnable,
                          checked: driver.value.isEnabled(),
                          disabled: togglingEnabled.value
                        }, null, 40, _hoisted_66),
                        _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t(driver.value.enabled_at ? 'common.fields.enabled' : 'common.fields.disabled')), 1),
                        (togglingEnabled.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_68))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(ErrorMessage), { name: "enable" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('drivers.fields.payment_mode')), 1),
                      _createVNode(_unref(Field), {
                        name: "paymentMode",
                        class: "form-select form-select-sm",
                        id: "paymentMode",
                        as: "select",
                        modelValue: driver.value.paymentMode,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((driver.value.paymentMode) = $event)),
                        onChange: onChangePaymentMode,
                        disabled: savingPaymentMode.value
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", {
                            selected: "",
                            value: _unref(DriverPaymentMode).MONTHLY
                          }, _toDisplayString(_ctx.$t('common.placeholders.' + _unref(DriverPaymentMode).MONTHLY)), 9, _hoisted_71),
                          _createElementVNode("option", {
                            value: _unref(DriverPaymentMode).PERCENTAGE
                          }, _toDisplayString(_ctx.$t('common.placeholders.' + _unref(DriverPaymentMode).PERCENTAGE)), 9, _hoisted_72)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("hr", { class: "detail-divider my-3" }, null, -1)),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t('drivers.forms.current_balance')), 1),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("span", _hoisted_76, _toDisplayString(_unref(StrHelper).formatBalance(driver.value.balance)), 1),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(_unref(branchSelected)?.currency_code), 1)
                      ])
                    ]),
                    (_unref(AuthService).isAdmin())
                      ? (_openBlock(), _createElementBlock("button", _hoisted_78, [
                          _cache[34] || (_cache[34] = _createElementVNode("em", { class: "fas fa-sliders me-1" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t('drivers.forms.manage_balance')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (driver.value.paymentMode === _unref(DriverPaymentMode).MONTHLY)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _createElementVNode("button", _hoisted_80, [
                          _cache[35] || (_cache[35] = _createElementVNode("em", { class: "fas fa-calendar-plus me-1" }, null, -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t('drivers.monthly_payments.open_modal')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"]),
      _createVNode(ImageLoader, {
        id: 'image-driver',
        resourceId: driver.value.id,
        path: _unref(pathDriver),
        event: driverEvent,
        onImageDriverLoaded: uploadImgDriver
      }, null, 8, ["resourceId", "path"]),
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("h6", _hoisted_83, _toDisplayString(_ctx.$t('drivers.detail.section_history')), 1),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["history-tab-pill", { active: activeHistoryTab.value === 'saldo' }]),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (activeHistoryTab.value = 'saldo'))
            }, [
              _cache[38] || (_cache[38] = _createElementVNode("em", { class: "fas fa-coins me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('drivers.detail.tab_saldo')), 1)
            ], 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["history-tab-pill", { active: activeHistoryTab.value === 'mensualidades' }]),
              onClick: _cache[14] || (_cache[14] = ($event: any) => (activeHistoryTab.value = 'mensualidades'))
            }, [
              _cache[39] || (_cache[39] = _createElementVNode("em", { class: "fas fa-calendar-check me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('drivers.detail.tab_mensualidades')), 1)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          (activeHistoryTab.value === 'saldo')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (recharges.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.$t('drivers.detail.empty_recharges')), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("table", _hoisted_88, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.recharges.col_date')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.recharges.col_amount')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.recharges.col_balance')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.recharges.col_actor')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.recharges.col_note')), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recharges.value, (r) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: r.id
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_89, [
                                    _cache[40] || (_cache[40] = _createElementVNode("em", { class: "fas fa-clock payhist-clock" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(dayjs).unix(r.created_at).format('DD/MM/YY HH:mm')), 1)
                                  ])
                                ]),
                                _createElementVNode("td", {
                                  class: _normalizeClass([r.amount >= 0 ? 'text-success' : 'text-danger', 'payhist-amount', 'fw-bold'])
                                }, _toDisplayString((r.amount >= 0 ? '+' : '') + (r.amount ?? 0).toLocaleString('es-CO') + ' COP'), 3),
                                _createElementVNode("td", _hoisted_90, _toDisplayString((r.balanceAfter ?? 0).toLocaleString('es-CO') + ' COP'), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_91, [
                                    _createElementVNode("span", _hoisted_92, _toDisplayString(initials(r.createdByName)), 1),
                                    _createTextVNode(" " + _toDisplayString(r.createdByName), 1)
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  (r.note)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(r.note), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_94, "—"))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.$t('drivers.detail.count_movements', { n: rechargesTotal.value }, rechargesTotal.value)), 1)
                    ], 64))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (monthlyPayments.value.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString(_ctx.$t('drivers.detail.empty_monthly_payments')), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("table", _hoisted_98, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.col_period')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.col_amount')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.col_actor')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.col_date')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.col_note')), 1),
                              _createElementVNode("th", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.col_status')), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlyPayments.value, (p) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: p.id,
                                class: _normalizeClass({ 'payhist-row-voided': p.status === 'voided' })
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_99, _toDisplayString(p.period), 1)
                                ]),
                                _createElementVNode("td", _hoisted_100, _toDisplayString((p.amount ?? 0).toLocaleString('es-CO') + ' COP'), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_101, [
                                    _createElementVNode("span", _hoisted_102, _toDisplayString(initials(p.createdByName)), 1),
                                    _createTextVNode(" " + _toDisplayString(p.createdByName), 1)
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_103, [
                                    _cache[41] || (_cache[41] = _createElementVNode("em", { class: "fas fa-clock payhist-clock" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_unref(dayjs).unix(p.created_at).format('DD/MM/YY HH:mm')), 1)
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  (p.note)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(p.note), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_105, "—"))
                                ]),
                                _createElementVNode("td", _hoisted_106, [
                                  (p.status === 'voided')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("span", _hoisted_107, [
                                          _cache[42] || (_cache[42] = _createElementVNode("em", { class: "fas fa-ban me-1" }, null, -1)),
                                          _createTextVNode(_toDisplayString(_ctx.$t('drivers.monthly_payments.badge_voided')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_108, [
                                          (p.voidReason)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(p.voidReason), 1))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", null, [
                                            _createTextVNode(_toDisplayString(_ctx.$t('drivers.monthly_payments.voided_by', { name: p.voidedByName })) + " ", 1),
                                            (p.voidedAt)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_110, " · " + _toDisplayString(_unref(dayjs).unix(p.voidedAt).format('DD/MM/YY HH:mm')), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "btn btn-sm btn-outline-danger",
                                        onClick: ($event: any) => (openVoidModal(p))
                                      }, [
                                        _cache[43] || (_cache[43] = _createElementVNode("em", { class: "fas fa-ban me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('drivers.monthly_payments.action_void')), 1)
                                      ], 8, _hoisted_111))
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.$t('drivers.detail.count_monthly', { n: monthlyPaymentsTotal.value }, monthlyPaymentsTotal.value)), 1)
                    ], 64))
              ], 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_113, [
      _createElementVNode("div", _hoisted_114, [
        _createElementVNode("div", _hoisted_115, [
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("div", _hoisted_117, [
              _cache[44] || (_cache[44] = _createElementVNode("span", { class: "modal-icon-chip" }, [
                _createElementVNode("em", { class: "fas fa-coins" })
              ], -1)),
              _createElementVNode("h6", _hoisted_118, _toDisplayString(_ctx.$t('drivers.forms.manage_balance_title')), 1)
            ]),
            _cache[45] || (_cache[45] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_119, [
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.$t('drivers.forms.current_balance')), 1),
              _createElementVNode("div", _hoisted_122, [
                _createElementVNode("span", _hoisted_123, _toDisplayString(_unref(StrHelper).formatBalance(driver.value.balance)), 1),
                _createElementVNode("span", _hoisted_124, _toDisplayString(_unref(branchSelected)?.currency_code), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.$t('drivers.forms.adjustment_type')), 1),
              _createElementVNode("div", _hoisted_127, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(adjustmentType.value === 'add' ? 'btn btn-outline-success active' : 'btn btn-outline-secondary'),
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (adjustmentType.value = 'add'))
                }, [
                  _cache[46] || (_cache[46] = _createElementVNode("em", { class: "fas fa-plus me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('drivers.forms.adjustment_add')), 1)
                ], 2),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(adjustmentType.value === 'subtract' ? 'btn btn-outline-secondary active' : 'btn btn-outline-secondary'),
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (adjustmentType.value = 'subtract'))
                }, [
                  _cache[47] || (_cache[47] = _createElementVNode("em", { class: "fas fa-minus me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t('drivers.forms.adjustment_subtract')), 1)
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t('drivers.forms.amount_cop')), 1),
              _createElementVNode("div", _hoisted_130, [
                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "input-group-text" }, "$", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((newBalance).value = $event)),
                  min: "0",
                  placeholder: _ctx.$t('drivers.forms.amount_placeholder')
                }, null, 8, _hoisted_131), [
                  [_vModelText, newBalance.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_132, [
              _createElementVNode("label", _hoisted_133, _toDisplayString(_ctx.$t('drivers.forms.recharge_note')), 1),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((rechargeNote).value = $event)),
                rows: "2",
                placeholder: _ctx.$t('drivers.forms.adjustment_note_placeholder')
              }, null, 8, _hoisted_134), [
                [_vModelText, rechargeNote.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_135, [
            _createElementVNode("button", _hoisted_136, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
            _createElementVNode("button", {
              onClick: addBalance,
              type: "button",
              class: "btn bg-gradient-primary",
              disabled: submittingBalance.value
            }, [
              (submittingBalance.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_138))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('drivers.forms.apply_adjustment')), 1)
            ], 8, _hoisted_137)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_139, [
      _createElementVNode("div", _hoisted_140, [
        _createElementVNode("div", _hoisted_141, [
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _cache[49] || (_cache[49] = _createElementVNode("span", { class: "modal-icon-chip" }, [
                _createElementVNode("em", { class: "fas fa-calendar-check" })
              ], -1)),
              _createElementVNode("h6", _hoisted_144, _toDisplayString(_ctx.$t('drivers.monthly_payments.modal_title')), 1)
            ]),
            _cache[50] || (_cache[50] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_145, [
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.$t('drivers.monthly_payments.field_period')), 1),
              _createElementVNode("div", _hoisted_148, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodOptions.value, (opt) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: opt.value,
                    type: "button",
                    class: _normalizeClass(["history-tab-pill", { active: monthlyPaymentPeriod.value === opt.value }]),
                    onClick: ($event: any) => (monthlyPaymentPeriod.value = opt.value)
                  }, _toDisplayString(opt.label), 11, _hoisted_149))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_150, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.field_amount')), 1),
              _createElementVNode("div", _hoisted_151, [
                _cache[51] || (_cache[51] = _createElementVNode("span", { class: "input-group-text" }, "$", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((monthlyPaymentAmount).value = $event)),
                  min: "0"
                }, null, 512), [
                  [_vModelText, monthlyPaymentAmount.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_152, [
              _cache[52] || (_cache[52] = _createElementVNode("em", { class: "fas fa-info-circle text-info mt-1 flex-shrink-0" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.info_registered_by', { name: currentUserName.value })), 1)
            ]),
            _createElementVNode("div", _hoisted_153, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('drivers.monthly_payments.field_note')), 1),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control mt-1",
                rows: "3",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((monthlyPaymentNote).value = $event)),
                placeholder: _ctx.$t('drivers.monthly_payments.placeholder_note')
              }, null, 8, _hoisted_154), [
                [_vModelText, monthlyPaymentNote.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_155, [
            _createElementVNode("button", _hoisted_156, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
            _createElementVNode("button", {
              onClick: addMonthlyPayment,
              type: "button",
              class: "btn bg-gradient-primary",
              disabled: submittingMonthlyPayment.value
            }, [
              (submittingMonthlyPayment.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_158))
                : (_openBlock(), _createElementBlock("em", _hoisted_159)),
              _createTextVNode(_toDisplayString(_ctx.$t('drivers.monthly_payments.action_register')), 1)
            ], 8, _hoisted_157)
          ])
        ])
      ])
    ]),
    _createVNode(VoidMonthlyPaymentModal, {
      ref_key: "voidModalRef",
      ref: voidModalRef,
      "driver-id": driver.value.id,
      onVoided: onPaymentVoided
    }, null, 8, ["driver-id"]),
    _createElementVNode("div", _hoisted_160, [
      _createElementVNode("div", _hoisted_161, [
        _createElementVNode("div", _hoisted_162, [
          _createElementVNode("div", _hoisted_163, [
            _createElementVNode("div", _hoisted_164, [
              _cache[53] || (_cache[53] = _createElementVNode("span", { class: "modal-icon-chip" }, [
                _createElementVNode("em", { class: "fas fa-envelope" })
              ], -1)),
              _createElementVNode("h6", _hoisted_165, _toDisplayString(_ctx.$t('users.forms.edit')), 1)
            ]),
            _cache[54] || (_cache[54] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createVNode(_unref(Form), {
            onSubmit: updateEmail,
            "validation-schema": _unref(schemaEmail)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", _hoisted_167, [
                  _createVNode(_unref(Field), {
                    name: "email",
                    type: "email",
                    modelValue: driver.value.email,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((driver.value.email) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _withDirectives(_createElementVNode("input", _mergeProps({
                        class: "form-control form-control-sm",
                        id: "email",
                        "aria-label": "Email",
                        "aria-describedby": "email-addon",
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                        placeholder: _ctx.$t('common.placeholders.email')
                      }, field), null, 16, _hoisted_168), [
                        [_vModelDynamic, field.value]
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_unref(ErrorMessage), { name: "email" })
                ])
              ]),
              _createElementVNode("div", _hoisted_169, [
                _createElementVNode("button", _hoisted_170, _toDisplayString(_ctx.$t('common.actions.close')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn bg-gradient-primary",
                  disabled: submittingEmail.value
                }, [
                  (submittingEmail.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_172))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                ], 8, _hoisted_171)
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_173, [
      _createElementVNode("div", _hoisted_174, [
        _createElementVNode("div", _hoisted_175, [
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("div", _hoisted_177, [
              _cache[55] || (_cache[55] = _createElementVNode("span", { class: "modal-icon-chip" }, [
                _createElementVNode("em", { class: "fas fa-key" })
              ], -1)),
              _createElementVNode("h6", _hoisted_178, _toDisplayString(_ctx.$t('users.forms.edit_password')), 1)
            ]),
            _cache[56] || (_cache[56] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createVNode(_unref(Form), {
            onSubmit: updatePassword,
            "validation-schema": _unref(schemaPassword)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_179, [
                _createElementVNode("div", _hoisted_180, [
                  _createVNode(_unref(Field), {
                    name: "password",
                    type: "password",
                    modelValue: driver.value.password,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((driver.value.password) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("div", _hoisted_181, [
                        _createElementVNode("span", {
                          style: {"cursor":"pointer"},
                          class: "input-group-text",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (showPassword.value = !showPassword.value))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa", showPassword.value ? 'fa-eye' : 'fa-eye-slash'])
                          }, null, 2)
                        ]),
                        _withDirectives(_createElementVNode("input", _mergeProps({
                          class: "form-control form-control-sm",
                          id: "password",
                          "aria-label": "Password",
                          "aria-describedby": "password-addon",
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          placeholder: _ctx.$t('common.placeholders.password')
                        }, field, {
                          type: showPassword.value ? 'text' : 'password'
                        }), null, 16, _hoisted_182), [
                          [_vModelDynamic, field.value]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_unref(ErrorMessage), { name: "password" })
                ])
              ]),
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("button", _hoisted_184, _toDisplayString(_ctx.$t('common.actions.close')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn bg-gradient-primary",
                  disabled: submittingPassword.value
                }, [
                  (submittingPassword.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_186))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                ], 8, _hoisted_185)
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ])
      ])
    ])
  ], 64))
}
}

})